import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'functionDisplay',
})
export class FunctionDisplayPipe implements PipeTransform {
  transform(value: any, displayFunction: (value: any) => string): string {
    return displayFunction(value);
  }
}
